import React from 'react'
import { useTheme } from '@emotion/react'
import { Button as BaseButton } from '@kc/alphabrands-component-library'
import { ButtonProps } from '@kc/alphabrands-component-library/dist/components/Button/Button'

const Button: React.FC<ButtonProps> = (props) => {
  const { button } = useTheme()

  let buttonProps
  if (props.inverted) {
    buttonProps = button.secondary || button
  } else {
    buttonProps = button.primary || button
  }

  return <BaseButton {...buttonProps} {...props} />
}

export default Button
